/**
 * API base URL for staff app fetch calls.
 * Dev (localhost or LAN IP): empty string → same-origin `/api` via Vite proxy.
 * Production: set VITE_API_URL or uses api.{hostname}.
 */
function resolveApiBaseUrl() {
  const fromEnv = import.meta.env.VITE_API_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim()) {
    return fromEnv.replace(/\/$/, '');
  }

  if (typeof window === 'undefined') {
    return 'http://localhost:4000';
  }

  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '';
  }

  // LAN dev (e.g. phone at 192.168.x.x:3000) — same-origin + Vite proxy
  if (
    /^192\.168\./.test(hostname) ||
    /^10\./.test(hostname) ||
    /^172\.(1[6-9]|2[0-9]|3[01])\./.test(hostname)
  ) {
    return '';
  }

  return `https://api.${hostname}`;
}

export const API_BASE_URL = resolveApiBaseUrl();
